  // import { Component, h, Host, State } from '@stencil/core';
  // import { createRouter, Route } from '../node_modules/stencil-router-v2';

  // const Router = createRouter();

  // @Component({
  //   tag: 'app-root',
  // })
  // export class AppRoot {
  //   @State() isAuthenticated: boolean = false;

  //   componentWillLoad() { //check cookies for isometrikUserId and userToken
  //     const cookies = document.cookie.split('; ').reduce((acc, cookie) => {
  //       const [key, value] = cookie.split('=');
  //       acc[key] = value;
  //       return acc;
  //     }, {} as Record<string, string>);

  //     this.isAuthenticated =
  //       cookies['isometrikUserId'] && cookies['userToken'] ? true : false;

  //     const urlParams = new URLSearchParams(window.location.search);
  //     const conversationId = urlParams.get('conversation');

  //     if (this.isAuthenticated) {
  //       if (conversationId) {
  //         Router.push(`/?conversation=${conversationId}`);
  //       } else {
  //         Router.push('/');
  //       }
  //     } else {
  //       Router.push('/login');
  //     }
  //   }

  //   render() {
  //     return (
  //       <Host >
  //         <Router.Switch > 
  //           <Route path="/" >
  //             <web-chat></web-chat>
  //           </Route>

  //           <Route path="/login">
  //             <login-page
  //               onTrySignup={() => Router.push('/signup')}
  //             ></login-page>
  //           </Route>

  //           <Route path="/signup">
  //             <signup-page
  //               onTryLogin={() => Router.push('/login')}
  //             ></signup-page>
  //           </Route>
  //         </Router.Switch>
  //       </Host>
  //     );
  //   }
  // }
